import { render } from "./MatingDetail.vue?vue&type=template&id=95273fb2&scoped=true"
import script from "./MatingDetail.vue?vue&type=script&lang=js"
export * from "./MatingDetail.vue?vue&type=script&lang=js"

import "./MatingDetail.vue?vue&type=style&index=0&id=95273fb2&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95273fb2"]])

export default __exports__